var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaymentMethodGooglepay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20264,
    y: 3.84766,
    width: 21,
    height: 14.3043,
    rx: 2,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0367 12.9951V10.9206H12.1074C12.5462 10.9206 12.9165 10.7735 13.2184 10.4836L13.2908 10.4101C13.8423 9.80979 13.806 8.87463 13.2184 8.31924C12.9245 8.02522 12.522 7.86595 12.1074 7.87412H10.3887V12.9951H11.0367ZM11.0368 10.2917V8.503H12.1238C12.3573 8.503 12.5787 8.59284 12.7437 8.75619C13.094 9.09922 13.102 9.67093 12.7639 10.0262C12.5988 10.2018 12.3653 10.2998 12.1238 10.2917H11.0368Z",
    fill: "#3C4043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3137 9.76487C16.036 9.5076 15.6576 9.37692 15.1786 9.37692C14.5628 9.37692 14.0999 9.60561 13.794 10.0589L14.3656 10.4223C14.5749 10.112 14.8607 9.9568 15.2229 9.9568C15.4524 9.9568 15.6737 10.0426 15.8468 10.1977C16.0159 10.3448 16.1125 10.5571 16.1125 10.7817V10.9328C15.8629 10.794 15.549 10.7205 15.1625 10.7205C14.7117 10.7205 14.3495 10.8266 14.0798 11.0431C13.8101 11.2595 13.6732 11.5454 13.6732 11.9088C13.6652 12.2396 13.8061 12.554 14.0556 12.7664C14.3092 12.9951 14.6312 13.1094 15.0096 13.1094C15.4564 13.1094 15.8106 12.9093 16.0803 12.5091H16.1085V12.9951H16.7283V10.8348C16.7283 10.3815 16.5915 10.0221 16.3137 9.76487ZM14.5549 12.3498C14.422 12.2518 14.3415 12.0926 14.3415 11.9211C14.3415 11.7291 14.4301 11.5699 14.6032 11.4433C14.7803 11.3167 15.0017 11.2513 15.2634 11.2513C15.6257 11.2472 15.9075 11.3289 16.1088 11.4923C16.1088 11.77 16.0001 12.0109 15.7868 12.2151C15.5935 12.4111 15.3318 12.5214 15.0581 12.5214C14.8769 12.5254 14.6998 12.4642 14.5549 12.3498Z",
    fill: "#3C4043"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1211 14.5346L20.2866 9.49127H19.5822L18.5799 12.0068H18.5679L17.5414 9.49127H16.837L18.2579 12.7705L17.4529 14.5346H18.1211Z",
    fill: "#3C4043"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7994 10.4713C8.7994 10.2712 8.7833 10.0711 8.7511 9.87512H6.01801V11.0063H7.5838C7.5194 11.3698 7.31009 11.6964 7.00418 11.9006V12.6357H7.93802C8.48544 12.1252 8.7994 11.3698 8.7994 10.4713Z",
    fill: "#4285F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01812 13.3463C6.79901 13.3463 7.45902 13.0849 7.93802 12.6357L7.00418 11.9006C6.74254 12.0803 6.40857 12.1824 6.01812 12.1824C5.26139 12.1824 4.62139 11.6638 4.39195 10.9696H3.42994V11.7291C3.92101 12.7215 4.92328 13.3463 6.01812 13.3463Z",
    fill: "#34A853"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39195 10.9696C4.27118 10.6061 4.27129 10.21 4.39206 9.84247V9.08699H3.42989C3.01523 9.91598 3.01523 10.8961 3.42989 11.725L4.39195 10.9696Z",
    fill: "#FBBC04"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01812 8.6296C6.43272 8.62144 6.83121 8.7807 7.12907 9.07064L7.95826 8.2294C7.43096 7.73119 6.73863 7.45759 6.01812 7.46575C4.92328 7.46575 3.92096 8.09465 3.42989 9.08699L4.39195 9.84654C4.62139 9.14823 5.26139 8.6296 6.01812 8.6296Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentMethodGooglepay);
export default __webpack_public_path__ + "static/media/icon_payment_method_googlepay.ea760a1c4a7bb6eadcc1c041a29e50ae.svg";
export { ForwardRef as ReactComponent };